import Cookies from 'js-cookie';

export default Cookies.withConverter({
  read: function (value, name) {
    if (name === 'u_co_name' || name === 'u_name') {
      value = value.replace(/\+/g, ' ');
    }
    return Cookies.converter.read(value, name);
  },
});
